export const getSongId = (song = {}) => song?.id || song?.song_id || song?.songId || null;

const isActiveStatus = (value) => {
  if (value === undefined || value === null || value === '') return true;
  return value === 1 || value === '1' || value === 'Active' || value === 'active' || value === true;
};

const isNotDeleted = (value) => {
  if (value === undefined || value === null || value === '') return true;
  return value === 0 || value === '0' || value === false;
};

export const isActiveArtistSong = (song = {}) => {
  const status = song?.status ?? song?.song_status ?? song?.songStatus ?? song?.songalbum_status ?? song?.album_status;
  const isDeleted = song?.is_delete ?? song?.is_deleted ?? song?.isDelete ?? song?.isDeleted ?? song?.songalbum_is_delete;
  return isActiveStatus(status) && isNotDeleted(isDeleted);
};

export const collectArtistDocuments = (songs = [], ownershipBySongId = {}) => {
  const docs = [];

  songs.forEach((song) => {
    if (!isActiveArtistSong(song)) return;

    const songId = getSongId(song);
    if (!songId) return;

    const ownership = song.ownership || ownershipBySongId[songId] || {};
    const groups = [
      { key: 'recordLabels', type: 'Recode label' },
      { key: 'lyrics', type: 'Lyrics' },
      { key: 'musicians', type: 'Melody' },
      { key: 'singers', type: 'Singer' }
    ];

    groups.forEach(({ key, type }) => {
      const items = Array.isArray(ownership[key]) ? ownership[key] : [];
      items.forEach((item) => {
        docs.push({
          id: item.mappingId || item.id || `${songId}-${key}-${Math.random()}`,
          songId,
          songName: song.name || song.title || 'Untitled Song',
          name: item.name || item.document_name || item.documentName || `${type} Document`,
          type,
          size: item.size || item.document_size || 'PDF Document',
          date: item.createdAt || item.created_at || item.updatedAt || item.updated_at || '',
          documentUrl: item.document_url || item.documentUrl || item.file_url || item.url || '',
          rawName: item.rawName || item.name || item.document_name || item.documentName || `${type} Document`,
          category: key,
          mappingId: item.mappingId || item.id || null,
          artist: item.artist || item.artistName || item.artist_name || null
        });
      });
    });
  });

  return docs;
};
